const TOKEN_KEY = "token";
const REFRESH_TOKEN_KEY = "refreshToken";
const IMPERSONATE_KEY = "imp";
const VIEWED_REG_VIDEO = "view_reg_video";
const REGISTER_TRACKER_UUID = "rt_uuid";
const REGISTER_TRACKER_REGISTERRED = "rt_reg";
const USER_IS_REGISTERED = "u_registered";
const ONBOARDING_AUTO_PLAYED_FIRST_LESSON = "onboarding_apfl"

class LocalStorageWrapper {
    constructor() {}

    setToken(token) {
        localStorage.setItem(TOKEN_KEY, token);
        return this;
    }

    getToken() {
        return localStorage.getItem(TOKEN_KEY);
    }

    clearToken() {
        localStorage.removeItem(TOKEN_KEY);
        return this;
    }

    setRefreshToken(refreshToken) {
        localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
        return this;
    }

    getRefreshToken() {
        return localStorage.getItem(REFRESH_TOKEN_KEY);
    }

    clearRefreshToken() {
        localStorage.removeItem(REFRESH_TOKEN_KEY);
        return this;
    }

    setImpersonate() {
        localStorage.setItem(IMPERSONATE_KEY, "true");
        return this;
    }

    clearImpersonate() {
        localStorage.removeItem(IMPERSONATE_KEY);
        return this;
    }

    isImpersonated() {
        return localStorage.getItem(IMPERSONATE_KEY) === "true";
    }

    clearAuthValues() {
        return this.clearToken().clearRefreshToken().clearImpersonate();
    }

    setUserRegistered() {
        localStorage.setItem(USER_IS_REGISTERED, "true");
        return this;
    }

    isUserRegistered() {
        return localStorage.getItem(USER_IS_REGISTERED) === "true";
    }

    setViewedRegVideo() {
        localStorage.setItem(VIEWED_REG_VIDEO, "true");
        return this;
    }

    isSetViewedRegVideo() {
        return localStorage.getItem(VIEWED_REG_VIDEO) === "true";
    }

    initializeRegisterTracker(uuid) {
        localStorage.setItem(REGISTER_TRACKER_UUID, uuid);
        return this;
    }

    finializedRegisterTracker() {
        localStorage.setItem(REGISTER_TRACKER_REGISTERRED, "true");
        return this;
    }

    isRegisterTrackerInitialized() {
        return !!localStorage.getItem(REGISTER_TRACKER_UUID);
    }

    isRegisterTrackerFinalized() {
        return localStorage.getItem(REGISTER_TRACKER_REGISTERRED) === "true";
    }

    getRegisterTrackerId() {
        return localStorage.getItem(REGISTER_TRACKER_UUID);
    }

    setOnboardingAutoPlayedForFirstLesson(userId) {
        localStorage.setItem(this.__get_onboarding_key(userId), "true");
        return this;
    }

    getOnboardingAutoPlayedForFirstLesson(userId) {
        return localStorage.getItem(this.__get_onboarding_key(userId)) === "true";
    }

    __get_onboarding_key(userId) {
        return `${ONBOARDING_AUTO_PLAYED_FIRST_LESSON}_${userId}`
    }
}

export const localStorageWrapper = new LocalStorageWrapper();
